import { Component, Input } from '@angular/core';
import { featureIconMap } from 'src/app/constants/app-constants';

@Component({
    selector: 'app-scene-profile-features',
    templateUrl: './scene-profile-features-tab.component.html',
    styleUrls: ['./scene-profile-features-tab.component.css'],
    standalone: false
})
export class SceneProfileFeaturesTabComponent {
  
  @Input() sceneFeaturesList: any;
  @Input() sceneStatus: string = '';
  @Input() activationReason: string = '';
  @Input() siteDetails: any;
  featureIconMap = featureIconMap;

  constructor() { }

  getWaterFeatureIconSrc(iconId: string): string {
    return `assets/img/${iconId}.svg`;
  }

  getFeatureIcon(category: string): string | null {
    return this.featureIconMap[category] || null;
  }

  getFeatureRouterLink(feature: any): any[] {
    switch (feature?.activityType) {
      case 'thermostat':
        return ['/equipment/thermostat-feature-profile',feature.featureId];
        default:
          return ['/equipment/featureProfile', feature.featureId] ;
      }
  }

  getControllerProfileRouterLink(feature: any): any[] {

    localStorage.setItem('isSceneFeature', 'true');
    localStorage.setItem('sceneStatus', this.sceneStatus);
    localStorage.setItem('activationReason', this.activationReason);

    if (this.siteDetails?.site_id && this.siteDetails?.site_name) {
      localStorage.setItem('siteId', JSON.stringify(this.siteDetails.site_id));
      localStorage.setItem('siteName', JSON.stringify(this.siteDetails.site_name));
    }

    return ['/equipment/detail', feature.controllerId];
  }

  setLocalStorage(feature: any): void {
      localStorage.setItem('selectedFeatureName', feature.featureName);
      localStorage.setItem('selectedFeatureCategory', feature.category);
  }

}
